<template>
  <div class="mainApp">
    <div v-if="true"><mainMenu/></div>
    <div v-else class="menuPlaceholder"><img class="logo" src="@/assets/GodEnergi_logo.svg"></div>
    <div class="scrollView" id="scrollView">
      <div class="header"></div>
      <div class="routerView"><router-view /></div>
      <div class="footer"></div>
    </div>
</div>
</template>

<script>
import mainMenu from './components/mainMenu.vue'
  //import { useRoute } from 'vue-router'
  //import { computed } from '@vue/runtime-core'

export default {
  components : { mainMenu },
  inject:[ 'wdm'],
  data() {
    return {
      login : false,
      loading: true,
      currentUser : '',
      currentUserName : '',
      currentValue : 'CV',
      currentDate: '',
      boxDates: [],
      accounts: [],
      onLine: navigator.onLine,
      
    }
  },
  created() {

    if (window.location.hostname == 'godservice-test.wedomobility.com') {
        window.document.title = '(TEST) GodService';  
        this.wdm.system = 'TEST';
      } else if (window.location.hostname == 'godservice.wedomobility.com') {
        window.document.title = '(DEV) GodService';
        this.wdm.system = 'DEV';
      } else if ('localhost192.168.1.119'.includes(window.location.hostname)) {
        window.document.title = '(Local) GodService';
        this.wdm.system = 'Local';
        //sessionStorage.setItem('userToken', $cookies.get('wdmUserToken'))
        //sessionStorage.setItem('refreshToken', $cookies.get('wdmRefreshToken'))
        //localStorage.setItem('user', $cookies.get('wdmUser'))
      } else {
        window.document.title = 'GodEnergi - GodService';
        this.wdm.system = 'PROD';
      };
 
  },
  mounted() {}
}
</script>

<style>

:root {
--godenergi-green    :  #81B532;
--godenergi-lightgreen : #C8D423;

}

#app {
  font-family: "Poppins", Sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
}

.logo { 
  height: 70px;
  margin-top: 20px;
  position: absolute;
  left: 50px;

}
.routerView {   
              border: 0px solid black;
              }

.maxedRouterView {
                padding-left: 10px;
                padding-right: 10px;
                margin-top: 10px;
                max-width: 1326px; 
}

h1 {
    font-size: 60px;
    font-weight: 700;
    line-height: 70px;
    letter-spacing: -0.79px;
    
}
.align-left {
  text-align: left;
}

.menuPlaceholder {
  height: 110px;
  background-color: var(--godenergi-green);
}

.scrollView {
  height: calc(100vh - 110px);
  overflow-y: auto ;

}

.white {
  color: white;
}
</style>
